<template>
    <b-row>
        <b-col cols="12">
            <h2 class="m-0 h1 text-uppercase">
                {{ $t('parcelas.selecciona_parcelas') }}
            </h2>
        </b-col>
        <b-col cols="12">
            <transition name="fade" mode="out-in">
                <b-row key="parcelas" id="parcelas">
                    <b-col cols="12" md="8">
                        <div class="d-flex justify-content-between align-items-center mb-2 mt-2 mt-md-0">
                            <h3 class="subtitle h3 light mb-3">{{ $t('parcelas.selecciona_parcelas') }}:</h3>
                            <Button @click="$emit('cambiarZona')">{{ $t('partido.cambiar_zona')}}</Button>
                        </div>
                        <ContentOrLoading>
                            <div class="lightgray-content" v-if="!loading && svgRendered">
                                <LeafletComponent
                                    :svgRendered="svgRendered"
                                    :originalColor="originalColor"
                                    :plazasSeleccionadas="parcelasSeleccionadas"
                                />
                            </div>
                        </ContentOrLoading>
                    </b-col>
                    <b-col class="mt-3 mt-md-5 pt-md-2" cols="12" md="4" v-if="parcelasSeleccionadas.length">
                        <b-row>
                            <b-col cols="12">
                                <div class="d-flex flex-column justify-content-between">
                                    <div class="overflow-auto">
                                        <div
                                            v-for="(parcela, index) in parcelasSeleccionadas"
                                            class="lightgray-content p-2 mb-2"
                                            :key="index"
                                        >
                                            <div class="text-bold mb-2 d-flex justify-content-between align-items-center">
                                                <div class="oswald d-flex">
                                                    {{ num = index + 1 }}.&nbsp; <span v-html="getParcelaName(parcela)"></span>
                                                </div>
                                                <span
                                                    role="button"
                                                    :aria-label="teatro.hash === 'J1fKG9AarPuPNJ5hwY0t' ? 'Eliminar terreno' : 'Eliminar parcela'"
                                                    @click="eliminarParcela(parcela)"
                                                    class="text-danger ml-2"
                                                    style="cursor: pointer; font-weight: bold; font-size: 20px;"
                                                >
                                                    &times;
                                                </span>
                                            </div>
                                            <div class="form-group mb-1">
                                                <ValidationProvider
                                                    :name="'precio' + index"
                                                    rules="required"
                                                    v-slot="{ errors }"
                                                >
                                                    <select
                                                        :class="'form-control ' + (errors[0] ? 'is-invalid' : '')"
                                                        v-model="parcela.precioSeleccionado"
                                                        name="precio"
                                                        data-cy="selectParcelas"
                                                    >
                                                        <option :value="undefined" disabled hidden>
                                                            {{ $t("parcelas.tipo_precio") }}
                                                        </option>
                                                        <option
                                                            v-for="(precio, index) in parcela.precios"
                                                            :key="index"
                                                            :value="precio"
                                                        >
                                                            {{ precio.descripcion }} | {{ precio.precio | formatear_precio }}
                                                        </option>
                                                    </select>
                                                </ValidationProvider>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </b-col>
                            <b-col cols="12" v-if="parcelasConPrecios">
                                <Button
                                    :label="$t('partido.continuar')"
                                    :disabled="loading"
                                    custom-class="btn btn-block"
                                    @click="continuarCompra"
                                />
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
            </transition>
        </b-col>
    </b-row>
</template>

<script>
    import LeafletComponent from '@/components/svg/components/LeafletComponent.vue';
    import { Popover } from 'bootstrap';
    import Button from '@/modules/ui/Button.vue';

    export default {
        props: {
            zona: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                parcelas: [],
                loading: false,
                svgRendered: null,
                originalColor: '#0CBA31',
                parcelasSeleccionadas: [],
                seleccionadaColor: '#457ad1',
                parcelas_max: 8
            }
        },
        methods: {
            getSvg() {
                const params = {
                    filters: {},
                    zona_id: this.zona.id
                }

                this.$store.dispatch(this.config.getVuexAlias('front.zonas.svg'), params).then(res => {
                    this.renderSvg(res.data.svg);
                }).catch(() => {
                    console.warn('Error al recuperar el svg en la configuración de precios de abonos');
                }).finally(() => {
                    this.loading = false;
                });
            },
            getParcelas() {
                this.loading = true;

                const params = {
                    filters: {},
                    lista_abonado_id: this.lista.id,
                    place_id: this.lista.recinto_parcela_id,
                    zona_id: this.zona.id
                }

                this.$store.dispatch(this.config.getVuexAlias('front.parcelas.zona.butacas'), params).then(res => {
                    this.parcelas = res.data.data?.filter(parcela => parcela.svg_id);
                    this.getSvg();
                }).finally(() => {
                    this.loading = false;
                });
            },
            renderSvg(svg) {
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = svg;

                const svgElement = tempDiv.firstElementChild;
                const parcelas = svgElement.querySelectorAll('[id^="butaca"]');
                const isMobile = window.innerWidth <= 768;

                parcelas.forEach(element => {
                    element.setAttribute('seleccionado', 'false');
                    const svg_id = this.getParcelaId(element);
                    const parcela = this.parcelas.find(parcela => parcela.svg_id == svg_id);

                    if (parcela) {
                        const title = this.getParcelaName(parcela);

                        if (!isMobile) {
                            this.drawPopover(element, parcela, title);
                        }

                        if(parcela.precios.length === 0) {
                            element.setAttribute('fill', 'gray');
                            parcela.originalColor = 'gray';
                        } else {
                            element.setAttribute('fill', this.originalColor);
                            parcela.originalColor = this.originalColor;
                        }

                        element.addEventListener('click', () => {
                            let isSeleccionado = JSON.parse(element.getAttribute('seleccionado'));

                            setTimeout(() => {
                                if (!this.isPanning) {
                                    if (!isSeleccionado) {
                                        element.setAttribute('fill', this.seleccionadaColor);
                                        element.setAttribute('seleccionado', 'true');
                                    } else {
                                        element.setAttribute('fill', parcela.originalColor);
                                        element.setAttribute('seleccionado', 'false');
                                    }
                                    this.clickParcela(parcela.id);
                                }
                            }, 150);
                        });
                    }
                });

                this.svgRendered = tempDiv.firstElementChild;
                setTimeout(() => {
                    this.$scrollTo('#plano', 50);
                }, 70);
            },
            getParcelaId(element) {
                const id = element.id;
                const idParts = id.split("-");

                return idParts[1];
            },
            getParcelaName(parcela) {
                const palabra = this.teatro.hash === 'J1fKG9AarPuPNJ5hwY0t' ? 'Terreno' : 'Parcela';
                return `${palabra} Nº ${parcela.numero}`;
            },
            drawPopover(element, parcela, title = null) {
                let content = '';

                const precios = this.generatePriceContent(parcela.precios);
                if (precios !== '') {
                    content += '<b>Precios:</b>';
                    content += precios;
                }

                const popoverOptions = {
                    title: title,
                    content: content,
                    trigger: 'hover',
                    html: true
                }

                new Popover(element, popoverOptions);
            },
            generatePriceContent(precios) {
                let content = '';

                content += '<ul class="pb-0 mb-0">';

                precios.forEach(precio => {
                    content += `<li>${precio.descripcion} | ${this.$n(precio.precio, 'currency')}</li>`;
                });

                content += '</ul>';

                return content;
            },
            clickParcela(parcela_id) {
                let parcelaSeleccionada = this.parcelas.find(parcela => parcela.id == parcela_id);

                if(this.parcelasSeleccionadas.length == this.parcelas_max) {
                    const palabra = this.teatro.hash === 'J1fKG9AarPuPNJ5hwY0t' ? 'terrenos' : 'parcelas';
                    this.$toast.error('Solo se pueden seleccionar ' + this.parcelas_max + ' ' + palabra + ' como máximo.');
                }

                if (parcelaSeleccionada && this.parcelasSeleccionadas.length < this.parcelas_max) {
                    parcelaSeleccionada.seleccionada = parcelaSeleccionada?.seleccionada && parcelaSeleccionada.seleccionada ? false : true;
                    if (parcelaSeleccionada.seleccionada) {
                        if (parcelaSeleccionada.precios.length === 1) {
                            parcelaSeleccionada.precioSeleccionado = parcelaSeleccionada.precios[0];
                        }
                        this.parcelasSeleccionadas.push(parcelaSeleccionada)
                    } else {
                        const index = this.parcelasSeleccionadas.findIndex(parcela => parcela.id == parcelaSeleccionada.id);

                        if (index !== -1) {
                            this.parcelasSeleccionadas.splice(index, 1);
                        }
                    }
                }
            },
            eliminarParcela(parcela) {
                const index = this.parcelasSeleccionadas.findIndex(p => p.id === parcela.id);
                if (index !== -1) {
                    this.parcelasSeleccionadas.splice(index, 1);
                }

                const svgElement = this.svgRendered?.querySelector(`#butaca-${parcela.svg_id}`);
                if (svgElement) {
                    svgElement.setAttribute('fill', parcela.originalColor || this.originalColor);
                    svgElement.setAttribute('seleccionado', 'false');
                }

                const parcelaOriginal = this.parcelas.find(p => p.id === parcela.id);
                if (parcelaOriginal) {
                    parcelaOriginal.seleccionada = false;
                }
            },
            continuarCompra() {
                this.loading = true;

                const params = {
                    lista_abonado_id: this.lista.id,
                    zona_id: this.zona.id,
                    parcelas: this.parcelasSeleccionadas.map(parcela => ({
                        id: parcela.id,
                        precio_id: parcela.precioSeleccionado.id
                    }))
                };

                this.$store.dispatch(this.config.getVuexAlias('front.parcelas.bloquear-parcelas'), params).then(res => {
                    if (this.teatro.hash === 'J1fKG9AarPuPNJ5hwY0t') {
                        this.$toast.success('Terrenos bloqueados correctamente');
                    } else {
                        this.$toast.success(res.data.message);
                    }
                    localStorage.setItem('session_id', res.data.session_id);
                    localStorage.setItem('cart_id', res.data.cart_id);
                    this.$emit('terminado', this.parcelasSeleccionadas);
                }).finally(() => {
                    this.loading = false;
                }).catch(error => {
                    this.$toast.error(error.response?.data?.message);
                    this.$emit('cambiarZona');
                });
            }
        },
        computed: {
            lista() {
                return this.$store.getters.getListaAbonados;
            },
            teatro() {
                return this.$store.getters.getTeatro;
            },
            parcelasConPrecios() {
                return this.parcelasSeleccionadas.every(parcela => parcela.precioSeleccionado);
            }
        },
        created() {
            this.getParcelas();
        },
        components: {
            LeafletComponent, Button
        }
    }
</script>
